const assetPath = (path) => `${process.env.PUBLIC_URL}${path}`;

export const portfolioStats = [
  { value: '3', label: 'Selected Projects' },
  { value: '4', label: 'Working Domains' },
  { value: '7 Weeks', label: 'Typical Project' },
];

export const portfolioCapabilities = ['Web', 'Backend', 'Systems', 'Embedded'];

export const projectCollection = [
  {
    id: 'leafree',
    number: '01',
    title: 'Leafree',
    category: 'AI Smart Farm Kit',
    accent: '#3f7d20',
    year: '2025',
    role: 'Team Lead',
    scope: 'Team Project',
    duration: '7 Weeks',
    period: '2025.04.15 - 2025.06.02',
    logoImage: assetPath('/project-files/Leafree/leafreeLogo-removebg.png'),
    logoScale: '1.02',
    showcaseMedia: [
      { type: 'logo', src: assetPath('/project-files/Leafree/leafreeLogo-removebg.png'), label: 'Leafree Logo' },
    ],
    cardImage: assetPath('/project-files/previews/leafree.png'),
    filters: ['embedded', 'iot'],
    prototypeImage: assetPath('/project-files/Leafree/prototype.png'),
    prototypeImages: [
      { src: assetPath('/project-files/Leafree/prototype.png'), label: 'Product Prototype', layout: 'full' },
      { src: assetPath('/project-files/Leafree/app1.jpeg'), label: 'App Screen 01', layout: 'phone-third' },
      { src: assetPath('/project-files/Leafree/app2.jpeg'), label: 'App Screen 02', layout: 'phone-third' },
      { src: assetPath('/project-files/Leafree/app3.jpeg'), label: 'App Screen 03', layout: 'phone-third' },
    ],
    introVideo: { src: assetPath('/project-files/Leafree/leafree.mp4'), label: 'Leafree Introduction Video' },
    headline: '식물 관리 경험을 자동 제어와 음성 인터랙션으로 확장한 스마트팜 키트',
    summary: '환경 제어, 자동 급수, 음성 인식, AI 캐릭터, 원격 앱 제어를 하나의 스마트팜 키트에 담았습니다.',
    techStack: [
      { label: 'Embedded', items: ['STM32', 'FreeRTOS', 'Sensor Control'] },
      { label: 'Edge AI', items: ['Raspberry Pi', 'Whisper Tiny', 'LLM', 'Qt'] },
      { label: 'App', items: ['Android', 'SpringBoot'] },
      { label: 'Hardware', items: ['DHT22', 'BH1750', 'MH-Z19', 'Water Pump', 'OLED'] },
    ],
    systemDiagram: {
      columns: [
        {
          title: 'Device Control',
          blocks: [
            { title: 'Air Solution', items: ['STM32', 'DHT22', 'BH1750', 'MH-Z19', 'Fan Control'] },
            { title: 'Water Solution', items: ['STM32', 'Soil Sensor', 'Pump', 'Relay'] },
          ],
        },
        {
          title: 'Edge Interface',
          blocks: [
            { title: 'User Interface', items: ['OLED', 'Voice Input', 'Qt Display'] },
            { title: 'Raspberry Pi', items: ['Whisper Tiny', 'LLM Character', 'MQTT Bridge'] },
          ],
        },
        {
          title: 'Mobile · Cloud',
          blocks: [
            { title: 'Android App', items: ['Remote Control', 'Status View'] },
            { title: 'Backend', items: ['SpringBoot', 'MQTT Sync'] },
          ],
        },
      ],
      bridges: ['UART · I2C · GPIO', 'MQTT · HTTP'],
    },
    contributions: [
      '팀 리드로서 전체 시스템 방향 정리',
      '센서 제어와 AI 인터페이스가 연결되는 흐름 조율',
      '디바이스와 원격 제어 경험이 함께 보이는 제품 구조 리드',
    ],
  },
  {
    id: 'javix',
    number: '02',
    title: 'Javix',
    category: 'Voice Assistant Platform',
    accent: '#b45309',
    year: '2025',
    role: 'Team Member',
    scope: 'Team Project',
    duration: '7 Weeks',
    period: '2025.02.25 - 2025.04.14',
    logoImage: assetPath('/project-files/logos/javix-mark-clean.png'),
    logoScale: '0.98',
    showcaseMedia: [
      { type: 'logo', src: assetPath('/project-files/logos/javix-mark-clean.png'), label: 'Javix Logo' },
    ],
    cardImage: assetPath('/project-files/previews/javix.png'),
    filters: ['systems', 'iot'],
    prototypeImage: assetPath('/project-files/Javix/prototype.jpg'),
    prototypeImages: [
      { src: assetPath('/project-files/Javix/prototype.jpg'), label: 'Product Prototype', layout: 'wide' },
      { src: assetPath('/project-files/Javix/app4.png'), label: 'App Screen 04', layout: 'wide' },
      { src: assetPath('/project-files/Javix/app1.png'), label: 'App Screen 01', layout: 'phone-third' },
      { src: assetPath('/project-files/Javix/app2.png'), label: 'App Screen 02', layout: 'phone-third' },
      { src: assetPath('/project-files/Javix/app3.png'), label: 'App Screen 03', layout: 'phone-third' },
    ],
    introVideo: null,
    headline: '멀티 디바이스 음성 이벤트를 하나의 AI 비서 경험으로 연결한 플랫폼',
    summary: '다양한 디바이스에서 발생하는 음성 이벤트를 하나의 서비스 흐름으로 묶고 AI 비서와 연결했습니다.',
    techStack: [
      { label: 'Languages', items: ['Python', 'C++', 'Java', 'JavaScript', 'HTML', 'CSS'] },
      { label: 'Frontend', items: ['React'] },
      { label: 'Backend', items: ['SpringBoot', 'FastAPI'] },
      { label: 'Domain', items: ['IoT Device', 'Voice Event', 'LLM Assistant'] },
    ],
    systemDiagram: {
      columns: [
        {
          title: 'Device Input',
          blocks: [
            { title: 'Home Devices', items: ['Voice Trigger', 'Wake Event', 'Context Signal'] },
            { title: 'IoT Runtime', items: ['Device State', 'Local Event Capture'] },
          ],
        },
        {
          title: 'Middleware Core',
          blocks: [
            { title: 'Control Middleware', items: ['멀티디바이스 제어', '이벤트 라우팅', '상태 동기화'] },
            { title: 'System Software', items: ['프로세스 제어', '명령 분배', '서비스 연결'] },
          ],
        },
        {
          title: 'Assistant Services',
          blocks: [
            { title: 'Service API', items: ['FastAPI', 'SpringBoot'] },
            { title: 'Experience Layer', items: ['LLM Assistant', 'React UI'] },
          ],
        },
      ],
      bridges: ['Device Event · Control API', 'Assistant Context · UI API'],
    },
    contributions: [
      '멀티디바이스를 제어하는 미들웨어 제작',
      '디바이스 이벤트를 처리하는 시스템 소프트웨어 구현',
      '서비스 계층과 연결되는 제어 흐름 설계',
    ],
  },
  {
    id: 'the-lee',
    number: '03',
    title: 'The Lee',
    category: 'Smart Office Robotics',
    accent: '#0f766e',
    year: '2025',
    role: 'Team Lead',
    scope: 'Team Project',
    duration: '7 Weeks',
    period: '2025.01.07 - 2025.02.24',
    logoImage: assetPath('/project-files/logos/the-lee-mark-clean.png'),
    logoScale: '0.98',
    archiveLogoShift: '14px',
    showcaseMedia: [
      { type: 'logo', src: assetPath('/project-files/logos/the-lee-mark-clean.png'), label: 'The Lee Logo' },
    ],
    cardImage: assetPath('/project-files/previews/the-lee.png'),
    filters: ['robotics', 'embedded'],
    prototypeImage: assetPath('/project-files/TheLee/prototype.png'),
    prototypeImages: [
      { src: assetPath('/project-files/TheLee/prototype.png'), label: 'Physical Prototype', layout: 'tall', column: 'left' },
      { src: assetPath('/project-files/TheLee/The_Lee_App.png'), label: 'App Prototype', layout: 'wide', column: 'right' },
    ],
    introVideo: { src: assetPath('/project-files/TheLee/The_Lee.mp4'), label: 'The Lee Introduction Video' },
    headline: '사무실 쓰레기 처리를 자동화하는 자율주행 로봇 시스템',
    summary: '자율주행, 센서 상태 판단, 쓰레기 분류 AI, 웹·모바일 호출을 하나의 제품 경험으로 연결했습니다.',
    techStack: [
      { label: 'Languages', items: ['Python', 'C++', 'Swift'] },
      { label: 'Platform', items: ['ROS', 'React', 'Django', 'SwiftUI', 'Firebase', 'AWS'] },
      { label: 'Hardware', items: ['Raspberry Pi 5', 'Jetson Nano', 'Arduino Uno', 'Lidar', 'IMU'] },
      { label: 'Protocol', items: ['MQTT', 'UART', 'HTTP'] },
    ],
    systemDiagram: {
      columns: [
        {
          title: 'Input · Sensing',
          blocks: [
            { title: 'Call Interface', items: ['React Web', 'SwiftUI App', 'Bluetooth Button'] },
            { title: 'Sensor Pack', items: ['Lidar', 'IMU', 'Odor Sensor', 'Ultrasonic'] },
          ],
        },
        {
          title: 'Robot Control',
          blocks: [
            { title: 'Raspberry Pi', items: ['ROS Mapping', 'Navigation Stack', 'Motor Control'] },
            { title: 'Jetson Nano', items: ['YOLOR-v8', 'Waste Classification'] },
          ],
        },
        {
          title: 'User · Data',
          blocks: [
            { title: 'Application Layer', items: ['React', 'SwiftUI', 'Firebase'] },
            { title: 'Server & Broker', items: ['Django', 'MQTT', 'AWS'] },
          ],
        },
      ],
      bridges: ['UART · ROS Topic', 'MQTT · HTTP'],
    },
    contributions: [
      '프로젝트 총괄과 팀 진행 방향 조율',
      'Jetson 환경 설정 및 라이다 테스트',
      'ROS Mapping Stack 구현',
      'YOLOR-v8 모델 경량화',
    ],
  },
  {
    id: 'on-device-ai-3d-simulation',
    number: '04',
    title: 'On-device AI 3D Simulation',
    category: 'Softcon Award Project',
    accent: '#38bdf8',
    year: '2024',
    role: 'Team Lead',
    scope: '2 Members',
    duration: '3 Months',
    period: '2024.03 - 2024.06',
    logoImage: assetPath('/project-files/logos/on-device-ai-mark.svg'),
    logoScale: '0.94',
    showcaseMedia: [
      { type: 'logo', src: assetPath('/project-files/logos/on-device-ai-mark.svg'), label: 'On-device AI 3D Simulation Logo' },
    ],
    cardImage: assetPath('/project-files/On-device_AI_3D_simulation/prototype.jpeg'),
    filters: ['embedded', 'systems'],
    prototypeImage: assetPath('/project-files/On-device_AI_3D_simulation/prototype.jpeg'),
    prototypeImages: [
      { src: assetPath('/project-files/On-device_AI_3D_simulation/prototype.jpeg'), label: 'Mobile Edge Prototype', layout: 'wide', column: 'left' },
      { src: assetPath('/project-files/On-device_AI_3D_simulation/app.png'), label: '3D Monitoring Screen', layout: 'wide', column: 'right' },
    ],
    introVideo: null,
    headline: 'Edge TPU 기반 객체 탐지와 LiDAR 데이터를 결합한 실시간 3D 관제 시스템',
    summary: 'Raspberry Pi, Edge TPU, 카메라, LiDAR를 하나의 이동형 엣지 디바이스로 묶어 객체 정보와 거리 데이터를 3D 시뮬레이션으로 전송했습니다.',
    techStack: [
      { label: 'Languages', items: ['Python', 'C/C++'] },
      { label: 'Edge AI', items: ['Edge TPU', 'PyCoral', 'YOLOv5'] },
      { label: 'Device', items: ['Raspberry Pi', 'Camera', 'LiDAR', 'USB Accelerator'] },
      { label: 'Integration', items: ['Pybind', 'Sensor Fusion', 'Network Transfer'] },
    ],
    systemDiagram: {
      image: assetPath('/project-files/On-device_AI_3D_simulation/architecture.png'),
      imageAlt: 'On-device AI 3D Simulation architecture',
      imageTone: 'light',
      columns: [
        {
          title: 'Mobile Edge Device',
          blocks: [
            { title: 'Sensing', items: ['Front Camera', 'Rear Camera', 'LiDAR'] },
            { title: 'Runtime', items: ['Raspberry Pi', 'USB Accelerator'] },
          ],
        },
        {
          title: 'On-device AI',
          blocks: [
            { title: 'Object Detection', items: ['YOLOv5', 'Edge TPU Inference', 'PyCoral'] },
            { title: 'Sensor Binding', items: ['C Driver', 'Pybind Module', 'Immediate Image Access'] },
          ],
        },
        {
          title: '3D Control View',
          blocks: [
            { title: 'Object Metadata', items: ['Class', 'Distance', 'Angle'] },
            { title: 'Simulation', items: ['Real-time Monitor', 'Control Server'] },
          ],
        },
      ],
      bridges: ['Camera · LiDAR Stream', 'Object Metadata · Distance Payload'],
    },
    contributions: [
      'Raspberry Pi 기반 이동형 엣지 디바이스 제작과 구현 리드',
      '카메라, LiDAR, USB Accelerator를 활용한 데이터 센싱 및 처리 흐름 구축',
      'Edge TPU 기반 YOLOv5 객체 탐지와 LiDAR 거리 데이터를 결합해 클래스·거리·각도 정보 산출',
      'C로 작성된 센서 드라이버를 Pybind로 모듈화해 Python 처리 파이프라인과 통합',
    ],
  },
  {
    id: 'memory-efficient-pipelined-parallelism',
    number: '05',
    title: 'Memory-Efficient Pipelined Parallelism',
    category: 'Edge TPU Real-time Research',
    accent: '#60a5fa',
    year: '2024',
    role: 'Individual Research',
    scope: '1 Member',
    duration: '7 Months',
    period: '2023.11 - 2024.06',
    logoImage: assetPath('/project-files/logos/memory-pipeline-mark.svg'),
    logoScale: '0.96',
    showcaseMedia: [
      { type: 'logo', src: assetPath('/project-files/logos/memory-pipeline-mark.svg'), label: 'Memory-Efficient Pipelined Parallelism Logo' },
    ],
    cardImage: assetPath('/project-files/Memory-Efficient_Pipelined_Parallelism/result_graph.png'),
    filters: ['systems', 'embedded'],
    prototypeImage: assetPath('/project-files/Memory-Efficient_Pipelined_Parallelism/result_graph.png'),
    prototypeImages: [
      { src: assetPath('/project-files/Memory-Efficient_Pipelined_Parallelism/result_graph.png'), label: 'Inference Time Result', layout: 'full' },
    ],
    prototypeTabTitle: '성과',
    introVideo: null,
    headline: 'Edge TPU 캐싱과 추론을 분리해 실시간 시스템의 불필요한 추론 시간을 줄인 연구',
    summary: 'Edge TPU의 비효율적인 캐싱 흐름을 드라이버 단에서 분석하고, 캐싱과 추론을 분리한 뒤 Time-Triggered Cyclic Executive Scheduling 관점으로 다중 TPU 실행 시간을 맞췄습니다.',
    techStack: [
      { label: 'Languages', items: ['C/C++', 'Python'] },
      { label: 'Runtime', items: ['Edge TPU', 'PyCoral Driver', 'Caching Control'] },
      { label: 'Scheduling', items: ['Real-time System', 'Cyclic Executive', 'Pipelined Parallelism'] },
      { label: 'Evaluation', items: ['Large Dummy CNN', 'Submodel Profiling'] },
    ],
    systemDiagram: {
      image: assetPath('/project-files/Memory-Efficient_Pipelined_Parallelism/architecture.png'),
      imageAlt: 'Memory-Efficient Pipelined Parallelism architecture',
      imageTone: 'light',
      columns: [
        {
          title: 'Model Runtime',
          blocks: [
            { title: 'Large Dummy CNN', items: ['Submodel Split', 'Execution Profiling'] },
            { title: 'Edge TPU Runtime', items: ['Cache Behavior', 'Inference Path'] },
          ],
        },
        {
          title: 'Driver Control',
          blocks: [
            { title: 'Driver Analysis', items: ['PyCoral Driver', 'Cache Function Hook'] },
            { title: 'Runtime Separation', items: ['Caching Phase', 'Inference Phase'] },
          ],
        },
        {
          title: 'Scheduling',
          blocks: [
            { title: 'Timing Model', items: ['TPU Cache Time', 'TPU Inference Time'] },
            { title: 'Result', items: ['Cyclic Executive', 'Average 10% Reduction'] },
          ],
        },
      ],
      bridges: ['Submodel Partition · Runtime Profile', 'Cache Phase · Inference Timeline'],
    },
    contributions: [
      'Edge TPU의 캐싱을 위해 불필요한 추론이 발생하는 드라이버 흐름 분석',
      '캐싱과 추론을 분리하기 위한 드라이버 함수 추가 및 실행 경로 정리',
      '여러 TPU의 캐싱·추론 시간을 맞추기 위해 Time-Triggered Cyclic Executive Scheduling 방식 설계',
      'Large Dummy CNN Model 기준 서브모델별 평균 약 10% 추론 시간 감축 확인',
    ],
  },
  {
    id: 'vehicle-risk-auto-report',
    number: '06',
    title: 'Vehicle Risk Detection & Auto Report',
    category: 'Embedded Safety System',
    accent: '#fb923c',
    year: '2023',
    role: 'Team Member',
    scope: '4 Members',
    duration: '2 Months',
    period: '2023.04 - 2023.06',
    logoImage: assetPath('/project-files/logos/adas-mark.svg'),
    logoScale: '0.96',
    showcaseMedia: [
      { type: 'logo', src: assetPath('/project-files/logos/adas-mark.svg'), label: 'Vehicle Risk Detection Logo' },
    ],
    cardImage: null,
    filters: ['embedded', 'iot'],
    prototypeImage: null,
    prototypeImages: [],
    introVideo: { src: assetPath('/project-files/ADAS/ADAS.MP4'), label: 'Vehicle Risk Detection Demo Video' },
    headline: '차량 위험 상황을 센서로 판단하고 GPS 위치를 RF 통신으로 자동 전송한 임베디드 시스템',
    summary: '압력 센서와 가속도 센서로 위험 상황을 판단하고, GPS 위도·경도 데이터를 RF 모듈을 통해 서버로 전송하는 자동 신고 흐름을 구현했습니다.',
    techStack: [
      { label: 'Languages', items: ['C/C++'] },
      { label: 'Sensors', items: ['Pressure Sensor', 'Accelerometer', 'GPS'] },
      { label: 'Communication', items: ['RF Module', 'Server Packet Transfer'] },
      { label: 'Logic', items: ['Risk Detection', 'Coordinate Parsing'] },
    ],
    systemDiagram: {
      columns: [
        {
          title: 'Sensing · Actuating',
          blocks: [
            { title: 'Sensing', items: ['Pressure Sensor 1', 'Pressure Sensor 2', 'Accelerometer'] },
            { title: 'Actuating', items: ['Camera', 'Servo Motor', 'Buzzer'] },
          ],
        },
        {
          title: 'Local Network',
          blocks: [
            { title: 'Raspberry Pi Nodes', items: ['Sensor RPi', 'Actuator RPi'] },
            { title: 'LAN Hub', items: ['Local Event Routing', 'Risk Signal Transfer'] },
          ],
        },
        {
          title: 'Telematics · Server',
          blocks: [
            { title: 'Telematics', items: ['RF Module', 'GPS Module', 'LED'] },
            { title: 'Server', items: ['RF Module', 'LCD', 'Emergency Switch'] },
          ],
        },
      ],
      bridges: ['RPi · LAN', 'RF Link · GPS Payload'],
    },
    contributions: [
      '위험 상황 감지 후 GPS 신호를 위도·경도 데이터로 변환하는 기능 구현',
      'RF 모듈을 활용해 위험 이벤트와 위치 정보를 서버로 전송하는 흐름 담당',
      '압력 센서와 가속도 센서를 활용해 페달 조작과 차량 가속도를 비교하는 위험 판단 로직 구성',
    ],
  },
];

export const contactChannels = [
  {
    id: 'github',
    title: 'GitHub',
    handle: '@HeeHeejun',
    href: 'https://github.com/HeeHeejun',
    accentRgb: '52, 211, 153',
    description: '프로젝트 코드와 업데이트를 가장 빠르게 확인할 수 있는 저장소입니다.',
    action: 'Repository',
  },
  {
    id: 'linkedin',
    title: 'LinkedIn',
    handle: 'linkedin.com/in/heeheejun',
    href: 'https://www.linkedin.com/in/heeheejun/',
    accentRgb: '96, 165, 250',
    description: '경력, 프로젝트 스토리, 기술 기반 협업 히스토리를 정리해두었습니다.',
    action: 'Profile',
  },
  {
    id: 'instagram',
    title: 'Instagram',
    handle: '@heeheejun',
    href: 'https://www.instagram.com/wheel__jun/',
    accentRgb: '251, 113, 133',
    description: '프로젝트 메이킹 과정과 개인 브랜딩 관련 포스트를 공유합니다.',
    action: 'Feed',
  },
];
